<div class="flex-container"
     [class.keep-quick-link-space]="hasQuickLink">
  @for (items of columns(); track $index; let last = $last) {
    <div class="flex-column-container">
      <div *ngFor="let item of items; trackBy: trackByFn; let itemLast = last;"
           [ngStyle]="itemStyle">
        <ng-container *ngIf="item.item?.link || item.item?.meta; else btn">
          <app-universal-link *ngIf="item.item?.meta | linkToUrl: item.item?.link as url"
                              [url]="url[0]"
                              [openNewWindow]="url[1]"
                              [content]="itemContent"
                              (linkClicked)="onItemClick(item)"/>
        </ng-container>
        <ng-template #btn>
          <button appFocusRemove
                  [class.auto-pointer]="!(item.item?.link || item.item?.segmented || item.item?.meta)"
                  (click)="item.item?.segmented ? onItemClick(item, $event) : onItemClick(item)">
            <ng-container [ngTemplateOutlet]="itemContent"/>
          </button>
        </ng-template>
        <ng-template #itemContent>
          <div class="flex-column-container" *ngIf="item.item as gridItem">
            <app-image-loading *ngIf="gridItem.image as img"
                               [clickable]="item.item && !!(item.item.link || item.item.segmented || item.item.meta)"
                               [src]="img.hash"
                               [alt]="gridItem.meta?.name ?? ''"
                               [widthCss]="imgWidthCss()"
                               [targetWidth]="imgWidth()"
                               [targetHeight]="imgWidth() * img.aspectRatio"/>
            @if (showTitle) {
              <div class="row-container space-between title-container">
                <span class="title">{{item.title}}</span>
                <app-image-loading src="assets/icon_index_cart.svg" *ngIf="item.showCart"
                                   [clickable]="item.item && !!(item.item.link || item.item.segmented || item.item.meta)"
                                   [targetWidth]="21"
                                   [targetHeight]="19"
                                   [alt]="item.title"/>
              </div>
            } @else if (!itemLast) {
              <div [style.height.px]="gapSize()"></div>
            }
          </div>
        </ng-template>
      </div>
    </div>
    @if (!last) {
      <div [style.width.px]="gapSize()"></div>
    }
  }
</div>
